/* eslint-disable */
export function timeSince(date, noSeconds) {
  const seconds = Math.floor((new Date() - date) / 1000)

  let interval = seconds / 31536000

  if (interval > 1) {
    return `${Math.floor(interval)} years ago`
  }
  interval = seconds / 2592000
  if (interval > 1) {
    return `${Math.floor(interval)} Months ago`
  }
  interval = seconds / 86400
  if (interval > 1) {
    return `${Math.floor(interval)} Days ago`
  }
  interval = seconds / 3600
  if (interval > 1) {
    return `${Math.floor(interval)} Hours ago`
  }
  interval = seconds / 60
  if (interval > 1) {
    return `${Math.floor(interval)} Minutes ago`
  }
  return noSeconds ? 'less than a minute ago' : `${Math.floor(seconds)} Seconds ago`
}
